<template>
  <b-modal
    id="moveStructureModal"
    :title="$translate('Move Folder')"
    hide-footer
    centered
    content-class="rounded-8"
    @show="getGeneralStructure"
    @hide="onResetData"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 px-1">
        <FolderTree
          v-for="value in generalStructureWithoutFiles.filter(({ id }) => id !== selectedStructure.id)"
          :key="value.id"
          :value="value"
          :on-change-tree-handler="onChangeTreeHandler"
          :user-access-list="userAccessList"
          :on-user-access-change="onUserAccessChange"
          action-type="move"
          :selected-structure="selectedStructure"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between">
        <b-button variant="outline-secondary" size="lg" class="px-65" :disabled="isLoading" @click="onClose">
          {{ 'cancel' | i18n }}
        </b-button>
        <b-button variant="primary" size="lg" class="px-65" :disabled="!userAccessList.length || isLoading" @click="moveStructure">
          {{ 'create' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import FolderTree from '../permissions/folder-tree';
import api from '../../../api';
import { NotificationMixin } from '../../../../mixins';

export default {
  name: 'MoveStructureModal',
  components: { FolderTree },
  mixins: [NotificationMixin],
  props: {
    selectedStructure: {
      type: Object,
      default: () => {},
    },
    findAndChangeItem: {
      type: Function,
      default: () => {},
    },
    getFullStructure: {
      type: Function,
      default: () => {},
    },
    rootFolderData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      generalStructureWithoutFiles: [],
      userAccessList: [],
      isLoading: false,
    };
  },
  methods: {
    onChangeTreeHandler(newValue) {
      const newGeneralStructure = this.findAndChangeItem({
        array: this.generalStructureWithoutFiles,
        condition: ({ id }) => id === newValue.id,
        newValues: { isOpen: !newValue.isOpen },
      });
      this.generalStructureWithoutFiles = newGeneralStructure;
    },
    async getGeneralStructure() {
      const generalStructureWithoutFiles = await api.viewStructure.getFullStructureWithoutFile();
      this.generalStructureWithoutFiles = [{ ...this.rootFolderData, childList: generalStructureWithoutFiles.resultList }];
    },
    onResetData() {
      this.generalStructureWithoutFiles = [];
      this.userAccessList = [];
      this.isLoading = false;
    },
    onClose() {
      this.onResetData();
      this.$root.$emit('bv::hide::modal', 'moveStructureModal');
    },
    onUserAccessChange(data) {
      if (data.id === this.userAccessList[0]) {
        this.userAccessList = [];
      } else {
        this.userAccessList = [data.id];
      }
    },
    async moveStructure() {
      try {
        const params = {
          name: this.selectedStructure.name,
          owned: this.userAccessList[0],
          isActive: this.selectedStructure.isActive,
        };

        await api.viewStructure.updateStructure({ id: this.selectedStructure.id, params });

        await this.getFullStructure();
        this.showNotification({ type: 'success', message: 'Folder has been successfully moved!' });
        this.onClose();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  border: 1px solid rgba(197, 208, 222, 0.40);
  border-radius: 8px;
  box-shadow: 4px 0px 16px rgba(15, 32, 65, 0.04);
}
.px-65 {
  padding-left: 65px;
  padding-right: 65px;
}
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
::v-deep .modal-body {
  padding-top: 10px !important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
